import styled from "@emotion/styled";
import Image from "next/image";
import React from "react";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import BuySellFilter from "@components/buy-sell-filter";

function CoverSection() {
  const translation = useTranslations("collection");

  const welcomeTitle = translation("title") || "";

  const [titleOne, titleTwo, ...rest] = welcomeTitle.split(" ");

  return (
    <Cover>
      <ContentCover>
        <TitlePrimary>
          {titleOne} {titleTwo} <br />
          <span>{rest.join(" ")}</span>
        </TitlePrimary>
        <ContentFilter>
          <BuySellFilter
            detailsRoute={CPagesPath.es.collection_property_detail}
            collection={true}
          ></BuySellFilter>
        </ContentFilter>
      </ContentCover>
    </Cover>
  );
}

export default CoverSection;

const ContentFilter = styled.div`
  display: flex;
  width: auto;
  justify-content: center;
  align-items: center;
  padding-top: 15vh;
  @media screen and (max-width: 500px) {
    padding-top: 10vh;
  }
`;

const ContentCover = styled.div`
  width: 80%;
  margin: auto;
  height: 80vh;
`;

const Cover = styled.article`
  background: linear-gradient(
      180deg,
      #0000 0%,
      #0000 78%,
      var(--color-brand-blue-collection-main) 100%
    ),
    url("/images/v2/pic/imagen-08.webp");
  width: 100%;
  height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 110px 0;
  margin-top: -34px;
  @media screen and (max-width: 500px) {
    padding: 70px 0;
  }
  // @media screen and (max-width: 500px) {
  //   background-position: center;
  //   background-size: cover;
  // }
`;

const CicleImage = styled.a`
  margin: auto;
`;

const TitlePrimary = styled.h1`
  margin-top: 5vh;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 3rem;
  color: white;
  font-family: var(--font-family);
  text-align: center;
  span {
    font-size: 3rem;
  }

  @media screen and (max-width: 768px) {
    margin-top: 10vh;
    font-size: 2rem;
    span {
      font-size: 2rem;
    }
  }
`;
